let store;

export function setStore(newStore) {
  store = newStore;
}

export function getStore() {
  return store;
}

export function getState() {
  return store ? store.getState() : null;
}

export default getStore;

